module.exports = __webpack_public_path__ + "img/logos_partner_12.501bc13d.svg";